import { set } from 'lodash';

import { COMPLETION_APP_TYPES, COMPLETION_APPTYPE_MODES_DICT } from '~/constants/completion';
import { STREAM_SOURCE_TYPES, STREAM_STATUS } from '~/constants/streamSourceType';

export const getAssetKey = (fracFleet, well, padId) => {
  if (padId) return `pad--${padId}`;
  if (fracFleet) return `pad--${fracFleet.current_pad_id || padId}`;
  if (well) return `well--${well.id}`;

  // Note: It currently supports pad and well
  return 'common';
};

export const getDefaultPadModeSetting = (
  fracFleet,
  well,
  appType = COMPLETION_APP_TYPES.fracMultiWellApp
) => {
  let result = {};

  if (fracFleet) {
    result = {
      mode: COMPLETION_APPTYPE_MODES_DICT[appType][0],
      selectedLine: undefined,
    };
  } else if (well) {
    result = {
      mode: 'custom',
      selectedAssets: [well.id],
    };
  }

  return result;
};

export const resolveActiveFracAsset = (assets, ignoreStatus = false) => {
  return assets.reduce((result, asset) => {
    const fracStream = (asset.app_streams || []).find(
      stream =>
        stream.source_type === STREAM_SOURCE_TYPES.FRAC &&
        (ignoreStatus || stream.status === STREAM_STATUS.ACTIVE)
    );

    if (
      !fracStream ||
      !fracStream.last_active_at ||
      (result && result.last_frac_at > fracStream.last_active_at)
    ) {
      return result;
    }

    return set(asset, 'last_frac_at', fracStream.last_active_at);
  }, null);
};

export const resolveActiveWirelineAsset = (assets, ignoreStatus = false) => {
  return assets.reduce((result, asset) => {
    const wirelineStream = (asset.app_streams || []).find(
      stream =>
        stream.source_type === STREAM_SOURCE_TYPES.WIRELINE &&
        (ignoreStatus || stream.status === STREAM_STATUS.ACTIVE)
    );

    if (
      !wirelineStream ||
      !wirelineStream.last_active_at ||
      (result && result.last_wireline_at > wirelineStream.last_active_at)
    ) {
      return result;
    }
    return set(asset, 'last_wireline_at', wirelineStream.last_active_at);
  }, null);
};

export const resolveActivePumpdownAsset = (assets, ignoreStatus = false) => {
  return assets.reduce((result, asset) => {
    const pumpdownStream = (asset.app_streams || []).find(
      stream =>
        stream.source_type === STREAM_SOURCE_TYPES.PUMPDOWN &&
        (ignoreStatus || stream.status === STREAM_STATUS.ACTIVE)
    );

    if (!pumpdownStream || (result && result.last_pumpdown_at > pumpdownStream.last_active_at)) {
      return result;
    }

    return set(asset, 'last_pumpdown_at', pumpdownStream.last_active_at);
  }, null);
};
